import React from 'react';
import { AirplaneIcon, HomeIcon, TaskIcon, UsersIcon, HistoryIcon, LogoutIcon, SettingsIcon } from './icons';
import './Header.css';

interface HeaderProps {
  activePage?: string;
  onPageChange?: (page: string) => void;
  onLogout?: () => void;
  currentUser?: {
    id: number;
    email: string;
    username: string;
    name: string; // firstName из API
    surname: string; // lastName из API
    role: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
  } | null;
}

const Header: React.FC<HeaderProps> = ({ 
  activePage = 'home', 
  onPageChange, 
  onLogout,
  currentUser
}) => {
  // Базовые элементы навигации для всех пользователей
  const baseNavItems = [
    { id: 'home', label: 'Главная', icon: HomeIcon },
    { id: 'tasks', label: 'Задачи', icon: TaskIcon },
  ];

  // Элементы навигации только для ADMIN
  const adminNavItems = [
    { id: 'members', label: 'Участники', icon: UsersIcon },
    { id: 'history', label: 'История', icon: HistoryIcon },
    { id: 'settings', label: 'Настройки', icon: SettingsIcon },
  ];

  // Формируем полный список элементов навигации в зависимости от роли
  const navItems = currentUser?.role === 'ADMIN' 
    ? [...baseNavItems, ...adminNavItems]
    : baseNavItems;

  return (
    <header className="header">
      <div className="header-contents">
        <div className="logo">
          <AirplaneIcon className="logo-icon" size={28} />
          <span className="logo-text">Airplanes</span>
        </div>
        
        <nav className="navigation">
          {navItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <button
                key={item.id}
                className={`nav-item ${activePage === item.id ? 'active' : ''}`}
                onClick={() => onPageChange?.(item.id)}
              >
                <IconComponent className="nav-icon" size={18} />
                <span className="nav-label">{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="header-actions">
          {currentUser && (
            <div className="user-info">
              <span className="user-name">{currentUser.name} {currentUser.surname}</span>
              <span className="user-role">{currentUser.role}</span>
            </div>
          )}
          <button className="logout-button" onClick={onLogout}>
            <LogoutIcon className="logout-icon" size={20} />
            <span className="logout-text">Выход</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 